export default __webpack_public_path__ + "static/media/kitten4L.e2622d09.webp";